var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.idProcesso
    ? _c(
        "div",
        [
          _vm.visualizarProcesso && _vm.idProcesso !== null
            ? _c("app-modal-visualizar-completo", {
                attrs: {
                  idProcesso: _vm.idProcesso,
                  protocolo: _vm.protocolo,
                  tipo: _vm.tipoProcesso,
                  numeroProcesso: _vm.numeroProcesso
                },
                on: {
                  closeModal: function($event) {
                    _vm.visualizarProcesso = false
                  }
                }
              })
            : _vm._e(),
          _vm.informacoes
            ? _c("app-modal-informacao", {
                attrs: {
                  idProcesso: _vm.idProcesso,
                  idDespacho: _vm.idDespacho,
                  setor: _vm.setorSelecionado,
                  setHasInformacoa: _vm.setHasInformacoa
                },
                on: {
                  closeModal: function($event) {
                    _vm.informacoes = false
                  },
                  setHasInformacoa: _vm.setHasInformacoa
                }
              })
            : _vm._e(),
          _vm.solicitarRetificacao
            ? _c("app-modal-solicitar-retificacao", {
                attrs: {
                  idProcesso: _vm.idProcesso,
                  numeroProcesso: _vm.numeroProcesso,
                  setor: _vm.setorSelecionado
                },
                on: {
                  closeModal: function($event) {
                    _vm.solicitarRetificacao = false
                  }
                }
              })
            : _vm._e(),
          _vm.notificarInteressado
            ? _c("app-modal-notificar-interessado", {
                attrs: {
                  idProcesso: _vm.idProcesso,
                  idDespacho: _vm.idDespacho,
                  isSubProcesso: _vm.isSubProcesso
                },
                on: {
                  closeModal: _vm.closeModalNotificarInteressado,
                  updateHasConversa: _vm.updateHasConversa
                }
              })
            : _vm._e(),
          _vm.legislacao
            ? _c("app-modal-legislacao", {
                on: {
                  closeModal: function($event) {
                    _vm.legislacao = false
                  }
                }
              })
            : _vm._e(),
          _vm.cancelarRetificacao
            ? _c("app-modal-cancelar-retificacao", {
                attrs: {
                  idProcesso: _vm.idProcesso,
                  numeroProcesso: _vm.numeroProcesso,
                  setor: _vm.setorSelecionado
                },
                on: {
                  closeModal: function($event) {
                    _vm.cancelarRetificacao = false
                  }
                }
              })
            : _vm._e(),
          _c(
            "el-dropdown",
            { staticClass: "margin-bottom", attrs: { trigger: "click" } },
            [
              _c("el-button", { attrs: { type: "info", size: "small" } }, [
                _vm._v("Opções"),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
              ]),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _vm.btnSolicitarInformacao && _vm.opcoesHeader
                    ? _c("el-dropdown-item", [
                        _c(
                          "div",
                          {
                            staticClass: "flex",
                            on: {
                              click: function($event) {
                                _vm.informacoes = true
                              }
                            }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons color-informacao"
                              },
                              [_vm._v("email")]
                            ),
                            _c("span", [
                              _vm._v(
                                "  " +
                                  _vm._s(
                                    !_vm.hasInformcao
                                      ? "Solicitar Informação"
                                      : "Informação"
                                  )
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm.btnRetificacao &&
                  _vm.opcoesHeader &&
                  _vm.processoRetificavel()
                    ? _c(
                        "div",
                        [
                          _vm.enableButton("SOLICITAR_RETIFICACAO") &&
                          !_vm.isEmissaoCertidao
                            ? _c("el-dropdown-item", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex",
                                    on: {
                                      click: function($event) {
                                        _vm.solicitarRetificacao = true
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass:
                                          "material-icons color-refresh color-retificacao"
                                      },
                                      [_vm._v("refresh")]
                                    ),
                                    _c("span", [
                                      _vm._v("  Solicitar Retificação")
                                    ])
                                  ]
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.btnNotificarInteressado
                    ? _c(
                        "div",
                        [
                          _vm.enableButton("NOTIFICAR_INTERESSADO")
                            ? _c("el-dropdown-item", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex",
                                    on: {
                                      click: function($event) {
                                        _vm.notificarInteressado = true
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass:
                                          "material-icons color-mensagem"
                                      },
                                      [_vm._v("sms")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        "  " +
                                          _vm._s(
                                            !_vm.hasConversa
                                              ? "Notificar Interessado"
                                              : "Mensagens"
                                          )
                                      )
                                    ])
                                  ]
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("el-dropdown-item", [
                    _c(
                      "div",
                      {
                        staticClass: "flex",
                        on: {
                          click: function($event) {
                            _vm.visualizarProcesso = true
                          }
                        }
                      },
                      [
                        _c(
                          "i",
                          {
                            staticClass:
                              "material-icons color-visualizar-processo"
                          },
                          [_vm._v("visibility")]
                        ),
                        _c("span", [_vm._v("  Visualizar processo")])
                      ]
                    )
                  ]),
                  _vm.conversaAberta && (_vm.isPa || _vm.isBa)
                    ? _c("el-dropdown-item", [
                        _c(
                          "div",
                          {
                            staticClass: "flex",
                            on: { click: _vm.fecharConversa }
                          },
                          [
                            _c(
                              "i",
                              { staticClass: "material-icons color-red" },
                              [_vm._v("close")]
                            ),
                            _c("span", [_vm._v("  Fechar conversas")])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm.emRetificacao && !_vm.isPa
                    ? _c("el-dropdown-item", [
                        _c(
                          "div",
                          {
                            staticClass: "flex",
                            on: {
                              click: function($event) {
                                _vm.cancelarRetificacao = true
                              }
                            }
                          },
                          [
                            _c(
                              "i",
                              { staticClass: "material-icons color-red" },
                              [_vm._v("close")]
                            ),
                            _c("span", [_vm._v("  Cancelar Retificação")])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm.EXIBIR_CONSULTA_LEGISLACAO
                    ? _c("el-dropdown-item", [
                        _c(
                          "div",
                          {
                            staticClass: "flex",
                            on: {
                              click: function($event) {
                                _vm.legislacao = true
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("search")
                            ]),
                            _c("span", [_vm._v("  Legislação")])
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c78a491", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c78a491","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/components/AppOpcoesHeaderAnalise.vue
// module id = null
// module chunks = 